import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Truck } from "lucide-react";

/**
 * Sitewide promo banner: "FIRST 50 CUSTOMERS SHIP FREE — N spots left".
 * Auto-hides once the cap is hit.
 */
export default function FreeShippingBanner() {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/promo/free-shipping")
      .then((r) => setPromo(r.data))
      .catch(() => setPromo(null));
  }, []);

  if (!promo || !promo.active) return null;

  return (
    <div
      data-testid="free-shipping-banner"
      className="mb-6 bg-[#DD5422] text-[#0A0E0B] border-2 border-[#DD5422] p-4 flex items-center justify-between gap-4 flex-wrap"
    >
      <div className="flex items-center gap-3">
        <Truck className="w-6 h-6 shrink-0" strokeWidth={2.5} />
        <div>
          <div className="font-anton text-lg md:text-xl uppercase tracking-wider leading-none">
            First 50 customers ship free
          </div>
          <div className="text-xs uppercase tracking-widest mt-1 opacity-90">
            ${promo.discount.toFixed(0)} off every order — auto-applied at checkout
          </div>
        </div>
      </div>
      <div className="text-right">
        <div className="font-anton text-3xl md:text-4xl uppercase leading-none" data-testid="free-shipping-remaining">
          {promo.remaining}
        </div>
        <div className="text-[10px] uppercase tracking-widest opacity-90">
          spot{promo.remaining === 1 ? "" : "s"} left
        </div>
      </div>
    </div>
  );
}
